import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import { MenuNode } from "../../api/generated";
import { CLEAR_PREVIEW_ITEM, SET_SELECTED_MENU } from "../../store/actions/configurationActions";
import { SET_SIDE_MENU_OPEN } from "../../store/actions/menuActions";
import { getMenuStructure, getSelectedMenu, getSideMenuOpen } from "../../store/sagas/selectors";

const MenuButton = styled.div`
    position: relative;
    cursor: pointer;
    pointer-events: auto;
    font-size: ${props => props.theme.paragraph.fontSize};
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 4px;
    color: black;
    margin: 0px 2px;
    padding: 6px;
    ${({ theme }) => theme.bp.md`
        margin: 5px 2px;
        padding: 10px;
    `}
    ${({ theme }) => theme.bp.lg`
        margin: 5px 10px;
    `}
    font-weight: 500;
    font-size: 14px;
    ${({ theme }) => theme.bp.md`
        font-size: 16px;
    `}
    transition: background-color 0.2s, color 0.2s;
    &:hover {
        background: rgba(229, 229, 229, 1);
    }
    &:active {
        background: rgba(215, 215, 215, 0.9);
    }
    &.active {
        background: rgba(51, 51, 51, 1);
        color: white;
    }
    p {
        margin: 0px;
    }
    animation: 1.5s ease-out 0s normal forwards 1 fadeIn, 0.5s ease 0s normal forwards 1 rise;
    opacity: 0;
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    @keyframes rise {
        from {
            top: 20px;
        }
        to {
            top: 0px;
        }
    }
`;

const MenuButtonsContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-content: center;
    height: 20%;
    z-index: 10;
    pointer-events: none;
    width: min(85vw, calc(100vw - 130px));
    ${({ theme }) => theme.bp.md`
        width: min(80vw, calc(100vw - 325px));
    `}
`;

const MenuButtonList = styled.div`
    width: 70vw;
    ${({ theme }) => theme.bp.md`
        width: 60vw;
    `}
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
`;

export const MainMenuButtons = () => {
    const dispatch = useDispatch();
    const menus = useSelector(getMenuStructure);
    const menuOpen = useSelector(getSideMenuOpen);
    const selectedMenu = useSelector(getSelectedMenu);
    return (
        <MenuButtonsContainer>
            <MenuButtonList>
                {menus.map((menu: MenuNode, i) => {
                    return (
                        <MenuButton
                            key={menu.id}
                            style={{ animationDelay: `${0.4 + 0.15 * i}s` }}
                            className={menuOpen && menu.id === selectedMenu ? "active" : undefined}
                            onClick={() => {
                                dispatch({ type: SET_SELECTED_MENU, selectedMenu: menu.id });
                                dispatch({ type: CLEAR_PREVIEW_ITEM });
                                dispatch({ type: SET_SIDE_MENU_OPEN, sideMenuOpen: true });
                            }}
                        >
                            <p>{menu.displayText || menu.id}</p>
                        </MenuButton>
                    );
                })}
            </MenuButtonList>
        </MenuButtonsContainer>
    );
};
